<template>
  <div>
    <Brands :key="keyComp" />
  </div>
</template>

<script>
import Brands from "../../components/brands/index.vue";
export default {
  components: {
    Brands,
  },
  data(){
    return {
      keyComp: 1
    }
  },
  watch: {
    '$route'(){
      this.keyComp ++;
    },
  }
};
</script>

<style>
</style>